module.exports = __webpack_public_path__ + "static/media/VEN.d25e95bd.svg";